module.exports = __webpack_public_path__ + "img/m-item07.8c0526a.png";